import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import { LogOut, Home, ArrowLeft, LayoutDashboard } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const { logout } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  
  const isNotDashboard = location.pathname !== '/admin/dashboard';

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-black">
      <nav className="bg-[#0A0A0A] border-b border-white/25 px-8 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-8">
            <Link to="/admin/dashboard">
              <img src="/deft-logo.jpg" alt="Deft Experiences" className="h-8" />
            </Link>
            <span className="body-large text-white">Admin Console</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/admin/dashboard" className="body-small text-white/60 hover:text-[#00FFD1] flex items-center gap-2">
              <LayoutDashboard size={16} />
              Dashboard
            </Link>
            <Link to="/" className="body-small text-white/60 hover:text-[#00FFD1] flex items-center gap-2">
              <Home size={16} />
              View Site
            </Link>
            <button onClick={handleLogout} className="body-small text-white/60 hover:text-red-500 flex items-center gap-2">
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </div>
      </nav>
      <div className="max-w-7xl mx-auto p-8">
        {isNotDashboard && (
          <button 
            onClick={() => navigate('/admin/dashboard')} 
            className="mb-6 flex items-center gap-2 text-white/60 hover:text-[#00FFD1] transition-colors"
            data-testid="back-to-dashboard-btn"
          >
            <ArrowLeft size={20} />
            <span className="body-medium">Back to Dashboard</span>
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
